var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors;
  return {
    blankBorderColor: colors.contrasts.grey1214,
    blankBorderRadius: '14px',
    blankMinWidth: '20px',
    blankHeight: '20px'
  };
};
export default generateComponentTheme;